export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/service-mask.4b917d21-85f51e.svg";